export const DEFAULT_LOAD_ORDER_STATUSES = [
  { code: 'BORRADOR', label: 'Borrador' },
  { code: 'PLANIFICADA', label: 'Planificada' },
  { code: 'CONFIRMADA', label: 'Confirmada' },
  { code: 'EN_CARGA', label: 'En carga' },
  { code: 'CARGADA', label: 'Cargada' },
  { code: 'EN_TRANSITO', label: 'En transito' },
  { code: 'ENTREGADA', label: 'Entregada' },
  { code: 'CANCELADA', label: 'Cancelada' },
];

export function loadOrderStatusLabel(code, statuses = DEFAULT_LOAD_ORDER_STATUSES) {
  return statuses.find((status) => status.code === code)?.label || code || '-';
}
